import React from 'react';
import { HeroCarousel } from '../components/HeroCarousel';
import { CoveredStartups } from '../components/CoveredStartups';
import { StoriesGrid } from '../components/StoriesGrid';
import { TrendingTopics } from '../components/TrendingTopics';

export default function Home() {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <HeroCarousel />
      </section>

      {/* Recent Stories */}
      <StoriesGrid />

      {/* Covered Startups Carousel */}
      <CoveredStartups />

      {/* Trending Topics */}
      <TrendingTopics />
    </div>
  );
}
